import { RawDraftContentState } from 'draft-js';

import { isEmpty } from 'Util/isEmpty';

import { Address } from './Address';
import { AvatarImage } from './AvatarImage';
import { Creator } from './Creator';
import { IndustryTypes } from './IndustryTypes';
import { MoneyValue } from './MoneyValue';
import { Nullable } from './Nullable';
import { SearchableEnumPresent } from './PropertyMap';
import { TextValue } from './TextValue';

export type OrgHourRate = {
    default: MoneyValue
}

export type Org = {
    id: string
    isDemo?: true
    name: Nullable<TextValue>
    logo: Nullable<AvatarImage>
    owner: Creator
    address: Nullable<Address>
    orgNr: Nullable<TextValue>
    offerTerms: Nullable<RawDraftContentState>
    hourRate: Nullable<OrgHourRate>
    industryTypes: SearchableEnumPresent<IndustryTypes.IndustryTypes>
}

export function noOrgNameText(orgName?: string) {
    return isEmpty(orgName) ? 'Navnløs org' : orgName
}
